import { getApiBaseUrl as getApiBaseUrlFromEnv, resolveEnvironment } from '@seede/api-client';

export const getApiBaseUrl = (): string => {
  return getApiBaseUrlFromEnv(resolveEnvironment());
};

const TOKEN_KEY = 'auth_token';

/**
 * 检查是否在客户端环境
 * 使用多重检查确保在 Nuxt SSR 环境中正确判断
 */
function isClient(): boolean {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

/**
 * 获取 token
 * @returns token 或 null
 */
export function getToken(): string | null {
  if (!isClient()) {
    return null;
  }
  try {
    return localStorage.getItem(TOKEN_KEY) ?? null;
  } catch (e) {
    console.warn('Failed to get token from localStorage:', e);
    return null;
  }
}

export const useApi = () => {
  const request = async (
    url: string,
    options: {
      method?: string;
      headers?: Record<string, string>;
      body?: any;
      query?: Record<string, any>;
    } = {}
  ) => {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token');
    }

    const apiBase = getApiBaseUrl();
    let requestUrl = url.startsWith('http') ? url : `${apiBase}${url}`;

    // Add query parameters
    if (options.query) {
      const queryString = new URLSearchParams(
        Object.entries(options.query).reduce(
          (acc, [key, value]) => {
            if (value !== undefined && value !== null) {
              acc[key] = String(value);
            }
            return acc;
          },
          {} as Record<string, string>
        )
      ).toString();
      requestUrl += `?${queryString}`;
    }

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    const response = await fetch(requestUrl, {
      method: (options.method || 'GET') as any,
      headers,
      body: options.body ? JSON.stringify(options.body) : undefined,
    });

    return response.json();
  };

  return {
    api: getApiBaseUrl(),
    request,
  };
};
